export default "__VITE_ASSET__01e27345__"